<button mat-icon-button class="copilot-launcher help-button" (click)="onClick()"
  [attr.aria-label]="'copilot.launcherAriaLabel' | translate" [matTooltip]="'copilot.launcherTooltip' | translate">
  <mat-icon>assistant</mat-icon>
</button>
